// extracted by mini-css-extract-plugin
module.exports = {"product":"products_product__1hNBC","icon":"products_icon__1J8oZ","itemTitle":"products_itemTitle__GhQ5W"};